import React from 'react';
import _get from 'lodash/get';
import pluralize from 'pluralize';
import { useSelector } from 'react-redux';
import useEntityTypes, { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';

// View
import Terminology from './Terminology';

export default function TerminologyContainer(props) {
  const entityTypes = useEntityTypes();
  const userConfig = _get(entityTypes, PERSON_ENTITY_TYPE_KEY);
  const teamLeader = _get(userConfig._fields, 'teamLeader.displayName', 'Leader');
  const terminologyState = useSelector(state => state.client.terminology);

  const terminology = {
    ...terminologyState,
    teamLeader,
    teamLeader_plural: pluralize(teamLeader),
  };

  return <Terminology {...props} terminology={terminology} />;
}
